import { render, staticRenderFns } from "./StTeaserImageText.vue?vue&type=template&id=e83c3d50"
import script from "./StTeaserImageText.vue?vue&type=script&lang=ts"
export * from "./StTeaserImageText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports